import LFCChartsBar from '_components/charts/LFCChartsBar';
import {ProgressAria} from '_components/ProgressAria';
import {getLFCData} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import dayjs from 'dayjs';
import {isEmpty} from 'lodash';
import {useSnackbar} from 'notistack';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {SearchConditions} from '../types';

interface DefectCountByPartChartProps {
  searchConditions: SearchConditions | null;
}

const DefectCountByPartChart: React.FC<DefectCountByPartChartProps> = ({searchConditions}) => {
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const [data60353, setData60353] = useState([]);
  const cancelSource = useRef<CancelTokenSource | null>(null);
  const [startProcess, setStartProcess] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      // アンマウント処理
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  useEffect(() => {
    if (searchConditions === null) return;

    if (cancelSource.current) cancelSource.current.cancel('req cancel');

    // 対象期間算出
    const now = dayjs();
    let fromDt = dayjs(`${now.format('YYYY-MM-DD')} ${searchConditions.select_time}`);

    // 稼働開始時刻より前の場合、前日の同時刻を開始時刻とする。
    if (searchConditions.select_time > now.format('HH:mm')) {
      // 稼働開始時刻
      fromDt = fromDt.add(-1, 'd');
    }
    const toDt = fromDt.add(1, 'd');

    setStartProcess(true);
    cancelSource.current = axios.CancelToken.source();
    getLFCData({
      snack: enqueueSnackbar,
      sql_id: 60353,
      parameters: {
        select_datetime_from: fromDt.format(),
        select_datetime_to: toDt.format(),
        work: !isEmpty(searchConditions.work) ? '{' + searchConditions.work.join(',') + '}' : null,
        deviceid: !isEmpty(searchConditions.deviceid)
          ? '{' + searchConditions.deviceid.join(',') + '}'
          : null,
        dongleid: !isEmpty(searchConditions.dongleid)
          ? '{' + searchConditions.dongleid.join(',') + '}'
          : null
      },
      ds_state: setData60353,
      name: `${t('不良数')}(${t('部位別')})`,
      cancelToken: cancelSource.current.token,
      t
    }).finally(() => {
      setStartProcess(false);
    });
  }, [searchConditions, enqueueSnackbar, t]);

  return (
    <ProgressAria startProcess={startProcess}>
      <LFCChartsBar
        title={`${t('不良数')}(${t('部位別')})`}
        source={data60353}
        x={{type: 'category', dsColumn: 'map'}}
        y={{type: 'value', dsColumn: 'count'}}
        exportData={data60353}
        exportFields={{
          map: t('部位'),
          count: t('件数')
        }}
        exportFilename={`${t('不良数')}(${t('部位別')})`}
        height="30vh"
      />
    </ProgressAria>
  );
};

export default DefectCountByPartChart;
